import {observer} from 'mobx-react';
import {auth, endpoints} from 'main/tools';
import {Select2} from 'shared/components';
import Employee from 'main/stores/employees/Employee';

const changeEmployee = (employeeId) => {
  window.location = window.location.pathname.replace(/\d+/, employeeId);
};

const EmployeeNavigationContainer = observer(({currentEmployee}) => {
  if (!auth.user.peopleDirectoryVisibility) {
    return <div className='h1 medium black'>{currentEmployee.name}</div>;
  }

  return (
    <div id='employee-navigation'>
      <div className='Employee-nav h1 medium black'>
        <Select2
          placeholder={currentEmployee.name}
          translatePlaceholder={false}
          onChange={e => changeEmployee(e.target.value)}
          searchable
          by='name'
          modelClass={Employee}
          endpoint={endpoints.EMPLOYEE_DIRECTORY.SEARCH}
          dropdownClass={'Employee-navigation'}>
          <option value={currentEmployee.id}>{currentEmployee.name}</option>
        </Select2>
      </div>
    </div>
  );
});

export default EmployeeNavigationContainer;
